import { render } from "./xterm.vue?vue&type=template&id=715c75f0&scoped=true"
import script from "./xterm.vue?vue&type=script&lang=js"
export * from "./xterm.vue?vue&type=script&lang=js"

import "./xterm.vue?vue&type=style&index=0&id=715c75f0&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715c75f0"]])

export default __exports__